// extracted by mini-css-extract-plugin
export default {"buttons":"Buttons_buttons__pAM5g","left":"Buttons_left__6pSWo","center":"Buttons_center__8xlj3","right":"Buttons_right__KGuMJ","between":"Buttons_between__SiJF1"};